import { BindingEngine, autoinject, bindable, bindingMode, customElement, observable } from 'aurelia-framework';
import { Router, activationStrategy } from 'aurelia-router';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
@autoinject
export class TextBoxBaseCustomElement extends BaseCustomElement {
    @bindable({ defaultBindingMode: bindingMode.toView }) label: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) columnName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) onChange: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) onBlur: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) forceChange: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) reset: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = -1;
    @bindable({ defaultBindingMode: bindingMode.toView }) creditCheckMainStatusId: number = null;
    @bindable placeholder: string = '';

    protected id: string = StringHelper.Empty();
    protected element: any = null;
    protected customElement: any = null;
    protected schema: Object = null;
    protected dataService: DataService = null;
    protected router: Router = null;
    protected autocompleteArray: Array<Object> = null;
    protected changeEventLock: boolean = false;
    protected expanded: boolean = false;
    protected index: number = -1;
    protected suggestionsUL: any = null;
    protected userInput: String = '';
    protected updatingInput: boolean = false;
    protected isAddedEventListenerOnBodyClick: boolean = false;
    protected enumType: string = null;

    protected myHideAutocompleteCallback: any = null;

    collapse() {
        this.expanded = false;
        this.index = -1;
    }

    constructor(element: Element, dataService: DataService, router: Router) {
        super();

        this.element = element;
        this.dataService = dataService;
        this.router = router;
        this.id = GuidHelper.NewGuid();

        this.myHideAutocompleteCallback = this.HideAutocomplete.bind(this);
    }


    keydown(key) {
        if (!this.expanded) {
            return true;
        }

        // down
        if (key === 40) {
            if (this.index < this.autocompleteArray.length - 1) {
                this.index++;
            } else {
                this.index = -1;
            }
            this.scroll();
            return;
        }

        // up
        if (key === 38) {
            if (this.index === -1) {
                this.index = this.autocompleteArray.length - 1;
            } else if (this.index > 0) {
                this.index--;
            } else {
                this.index = -1;
            }
            this.scroll();
            return;
        }

        // escape
        if (key === 27) {
            return;
        }

        // enter
        if (key === 13) {
            if (this.index >= 0) {
                this.select(this.autocompleteArray[this.index]);
                this.collapse();
            }
            return;
        }

        return true;
    }

    scroll() {
        const ul = this.suggestionsUL;
        const li = ul.children.item(this.index === -1 ? 0 : this.index);
        if (li.offsetTop + li.offsetHeight > ul.offsetHeight) {
            ul.scrollTop += li.offsetHeight;
        } else if (li.offsetTop < ul.scrollTop) {
            ul.scrollTop = li.offsetTop;
        }
    }

    async select(selectedItem) {
        await this.SelectAutocompleteValue(selectedItem.Caption);
    }


    focus() {
        this.element.firstElementChild.focus();
    }

    blur() {
        if (ObjectHelper.ObjectIs(this.onBlur)) {
            this.onBlur();
        }
    }

    async bind() {
        this.schema = await SystemService.Instance.GetSchemaByEntity(this.entityName);
        this.enumType = await SystemService.Instance.GetEnumType(this.entityName, this.columnName);
    }

    attached() {
        this.customElement = ($(this.element) as any);
    }

    detached() {
        // document.getElementById(`${this.id}-${this.entityName + '-' + this.columnName}-Caption`).removeEventListener("keydown");
        document.body.removeEventListener('click', this.myHideAutocompleteCallback);
    }

    async valueChanged(newValue, oldValue) {
        if (this.index != -1) {
            return;
        } else if (this.index == -1 && newValue === oldValue) {
            return;
        }
        // check if new value isn't null or empty
        if (await ObjectHelper.IsNullOrUndefined(newValue) || await StringHelper.IsNullOrEmpty(newValue)) {
            //this.caption = null;
            //await this.UpdateEntityDescritption(null);
        }
        //
        if (!this.changeEventLock && ObjectHelper.IsNotNullAndUndefined(newValue) && !StringHelper.IsNullOrEmptyOrUndefined(newValue) && this.StringIs(this.enumType)) {
            // load data from server

            let response = await SystemService.Instance.GetEnumeration(this.enumType, null, newValue);
            if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response['Items'])) {
                this.autocompleteArray = (JSON.parse(JSON.stringify(response['Items'])));
            }

            this.expanded = ObjectHelper.IsNotNullAndUndefined(this.autocompleteArray)
                && (
                    (this.autocompleteArray.length > 1)
                    ||
                    (this.autocompleteArray.length == 1 && this.autocompleteArray[0]['Caption'] != newValue)
                );
            //      
            this.customElement.find('[role="autocomplete"]').show();

            if (!this.isAddedEventListenerOnBodyClick) {
                document.body.addEventListener('click', this.myHideAutocompleteCallback, false);
                this.isAddedEventListenerOnBodyClick = true;
            }
        } else {
            this.autocompleteArray = null;
        }

        this.changeEventLock = false;

        if (await ObjectHelper.IsNotNullAndUndefined(this.onChange) && !this.forceChange) {
            this.onChange();
        }
    }

    async captionChanged(newValue, oldValue) {
        this.changeEventLock = false;
    }

    public async HideAutocomplete() {
        this.removeAutocompleteEventListener();
    }


    removeAutocompleteEventListener() {
        if (this.isAddedEventListenerOnBodyClick) {
            document.body.removeEventListener('click', this.myHideAutocompleteCallback, false);
            this.customElement.find('[role="autocomplete"]').hide();
            this.isAddedEventListenerOnBodyClick = false;
        }
    }

    public async SelectAutocompleteValue(caption: string) {
        this.changeEventLock = true;

        this.value = caption;
        await this.HideAutocomplete();
    }

}